module.exports = "/images/aerial-16.jpg";